import { createUseStyles } from "react-jss";
import { colors } from "../../../../constants/colors";

const contentStyles = createUseStyles({
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
  },
  h3: {
    margin: "0px",
    fontSize: "18px",
    fontWeight: "600",
    lineHeight: "28px",
    color: colors.mediumGrey,
    paddingLeft: "20px",
  },
  h4: {
    margin: "0px",
    fontSize: "18px",
    fontWeight: "600",
    lineHeight: "28px",
    color: colors.mediumGrey,
  },
  p: {
    margin: "0px",
    fontSize: "18px",
    fontWeight: "400",
    lineHeight: "28px",
    color: colors.mediumGrey,
  },
  ul: {
    margin: "0px",
    paddingLeft: "40px",
    listStyleType: "disc",
  },
  ulDash: {
    margin: "0px",
    paddingLeft: "40px",
    "& li::marker": {
      content: '"-  "',
    },
  },
  li: {
    fontSize: "18px",
    fontWeight: "400",
    lineHeight: "28px",
    color: colors.mediumGrey,
  },
  a: {
    color: colors.deepBlue,
    textDecoration: "none",
    fontWeight: "600",
  },
  strong: {
    extend: "p",
    fontWeight: "600",
  },
  underline: {
    extend: "p",
    textDecoration: "underline",
  },
});

export default contentStyles;
